module.exports = __webpack_public_path__ + "static/img/buying_six.7644d9de.jpg";